// RNIRegistration.jsx
import React from "react";

export default function RNIRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            RNI Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            RNI Registration for Newspapers & Publications
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists publishers with RNI Registration in
            compliance with the Press and Registration of Books Act for
            newspapers, magazines, and periodicals.
          </p>
          <p className="text-gray-700">
            From title verification through Press Sewa Portal to declaration
            authentication with District Magistrate, first issue printing, and
            final RNI certificate issuance, the complete registration process is
            managed professionally.
          </p>
        </div>

        {/* Right: Image (square for consistency - TOPIC-SPECIFIC: Newspaper publishing) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/267586/pexels-photo-267586.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Newspaper publishing press and RNI registration compliance"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for RNI Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks helps publishers compile all documentation
              required for title verification, declaration authentication, and
              final RNI registration approval.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Publisher identity proof (Aadhaar, PAN, Voter ID, or Passport).</li>
                <li>
                  Title verification documents including proposed publication
                  title, language, periodicity, and place of publication.
                </li>
                <li>
                  Printing press details with press ownership proof, layout, and
                  capacity certification from the printing facility.
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm provides specialized publishing compliance services with
              expertise in RNI registration procedures and Press Registrar
              requirements.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Publishing Compliance Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete knowledge of Press and Registration of Books Act,
                  RNI title verification, declaration authentication, and
                  publication compliance standards.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Documentation Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Precise Press Sewa Portal applications, DM declaration
                  coordination, first issue compliance, and complete document
                  packages for swift RNI approval.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Professional Regulatory Assistance
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end support from title availability check through DM
                  authentication, first issue printing compliance, RNI
                  submission, and certificate issuance for legal publication.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
